<div class="page-content container">
    <div class="page-header"><h1>{{ translationManager.getTranslation('Корисник') }}</h1></div>
    <div class="page-data shadow-sm">
      <div class="form-blocks">
        <div>
          <div class="content">
            <div class="form-element"><input type="hidden" name="id" [(ngModel)]="form.elements['id'].value"></div>

            <div class="page-part">
              <div class="form-element">
                <label>{{translationManager.getTranslation('Име и презиме')}}</label>
                <div class="content">
                  <div class="static"><span>{{ form.elements["name"].value | appvalue }}</span></div>
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="form-element">
                <label>{{translationManager.getTranslation('Назив компаније')}}</label>
                <div class="content">
                  <div class="static"><span>{{ form.elements["company"].value | appvalue }}</span></div>
                </div>
              </div>
            </div>
            <div class="page-part" *ngIf="form.elements['photo'].value">
                <div class="form-element">
                  <div class="content">
                    <img style="width: 400px;height: 400px; background-color: #e61212" src="{{photoimg}}"
                    alt="image" iscopyblocked="false">
                  </div>
                </div>
              </div>
            <div class="page-part" >
              <div class="form-element">

                <div style="margin-top:  5px; margin-bottom:  5px;">
                  <button (click)="file.click()"><i class="fa fa-camera mr-1"></i> {{
                    translationManager.getTranslation('SupplierUser_Photo') }}</button>
                  <input type="file" id="file" accept="image/jpeg"
                         (change)="handleFileInput($event.target.files)" #file style="display :none;">
                </div>
                <div style="margin-top:  5px; margin-bottom:  5px;">
                 <a *ngIf="form.elements['photo'].value"
                     href="javascript:;" (click)="removePhoto()" class="red"
                     [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>
                </div>
              </div>
            </div>



            <div class="form-element-buttons">
              <button class="btn btn-warning fl" (click)="navigateToList()">
                <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
              <button class="btn btn-success fr" (click)="submit()">
                <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
